export default (curlString: string): string => {
  return JSON.stringify(curlString);
};
